<template>
  <div>
    <v-navigation-drawer 
    id="left-menu"
    app
    permanent
    width="90"             
    style="
      box-shadow: 0 0 0.5em black;
      background: linear-gradient(to top, #1D8AFF  0%, #42A5F5 100%);
      display: flex;
      flex-direction: column;
    "
    v-if="isLoggedIn"
    >
      <!-- Cabeçalho do menu lateral -->
      <div class="d-flex align-center pa-5" style="display: flex;justify-content: center;">
        <v-img alt="Foz Logo" class="shrink mr-2 clickable-logo" 
          contain src="@/assets/menuIcons/logo.png" transition="scale-transition"
          width="24" style="cursor: pointer; margin-left: 10px" 
          @click="$router.push('/consumption')" />
      </div>

      <!-- Área principal do menu -->
      <v-list nav dense style="color: white;">
       
        <!-- Divisor abaixo do topo -->
        <v-divider color="white" style="width: 32px;display: flex;justify-self: center;height: 1px;margin: 12px;"></v-divider>

        <v-list-item 
          v-for="item in itemsMenuFilter"
          :key="item.title"
          @click="routerDuplicated(item)"
          link
          :class="[
            'sidebar-item',
            { 'sidebar-item--active': isActive(item) }
          ]"
        >
          <v-list-item-icon>
            <v-icon v-if="isMdiIcon(item.icon)" style="color: white;">{{ item.icon }}</v-icon>
            <v-img v-else-if="item.icon" width="24" height="24" :src="item.icon" contain/>
            <div v-html="item.image"></div>
          </v-list-item-icon>
          <v-list-item-title class="sidebar-item__title">{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>

      
      <!-- Área do usuário e logout (fixado na parte inferior) -->
      <template v-slot:append>
        <v-divider color="white" v-if="!mini"></v-divider>
        
        <v-list nav dense style="color: white;">
          <!-- <v-list-item >
            <v-list-item-icon>
              <v-avatar color="white" size="32">
                <v-img v-if="getCurrentUser.data.metadata.imageURL && getCurrentUser.data.metadata.imageURL.length > 0" 
                       :src="getCurrentUser.data.metadata.imageURL">
                </v-img>
                <v-img v-else src="https://cdn.pixabay.com/photo/2013/07/13/12/07/avatar-159236_640.png"></v-img>
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-content v-if="!mini">
              <v-list-item-title style="color: white;">{{ getCurrentUserName }}</v-list-item-title>
              <v-list-item-subtitle style="color: rgba(255,255,255,0.7);">{{ getCurrentUserRank }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
          <v-divider color="white" style="width: 32px;display: flex;justify-self: center;height: 1px;margin: 12px;"></v-divider>

          <div style="width: 100%;display: flex;justify-content: center;">
            <div style="width: 32px;display: flex;justify-content: center;">
              <v-list-item @click="confirmLogout" link class="logout-item sidebar-item">
                <v-list-item-icon>
                  <v-icon style="color: white;">mdi-logout</v-icon>
                </v-list-item-icon> 
              </v-list-item>
            </div>
          </div>
        </v-list>
        
      </template>
    </v-navigation-drawer>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RoutesPath } from '@/router/paths.js';
import { MenuFeatures,SubMenuFeatures } from "@/router/features.js";
import { hasMigratedFeature, isMigratedFeature } from "@/router/migratedFeatures.js";
import store from '@/store/index';

export default {
  name: "Sidebar",
  props: {
    value: {
      type: Boolean,
      default: true
    },
    miniValue: {
      type: Boolean,
      default: true
    }
  },
  // Atalho único que substitui, no menu, todas as telas migradas para a nova
  // plataforma (ver @/router/migratedFeatures.js).
  migratedMenuItem: {
    title: "Telemetria",
    icon: require("@/assets/menuIcons/attention.png"),
    path: RoutesPath.MIGRATED,
  },

  data: () => ({
    drawer: true,
    mini: true,
    showUserMenu: false,
    userMenuPositionX: 0,
    userMenuPositionY: 0,
    subitems: [
      {
        title: "Projetos",
        icon: "mdi-clipboard-list-outline",
        path: RoutesPath.PROJECTS,
        feature: MenuFeatures.PROJECTS,
      },
      {
        title: "Kits",
        icon: "mdi-toolbox-outline",
        path: RoutesPath.PROJECTS_KITS,
        feature: SubMenuFeatures.PROJECTS_KITS,
      },
      {
        title: "Propostas Kits",
        icon: "mdi-file-document-outline",
        path: RoutesPath.PROPOSALS,
        feature: SubMenuFeatures.PROPOSALS,
      },
      {
        title: "Water Scan",
        icon: "mdi-domain",
        path: RoutesPath.CHOOSE_WATER_SCAN,
        feature: MenuFeatures.WATERSCAM,
      },
      {
        title: "Water Fix",
        icon: "mdi-pipe-wrench",
        path: RoutesPath.CHOOSE_WATER_FIX,
        feature: MenuFeatures.WATERFIX,
      },
      {
        title: "Soluções",
        icon: "mdi-package-variant-closed",
        path: RoutesPath.CHOOSE_SOLUTION,
        feature: MenuFeatures.SOLUTIONS,
      },
    ],
    items: [
      {
        title: "Painel",
        icon: require("@/assets/menuIcons/dashboard.png"),
        path: RoutesPath.DASHBOARD,
        feature: MenuFeatures.DASHBOARD,
      },
      {
        title: 'Consumo',
        icon: require("@/assets/menuIcons/consumption.png"),
        path: RoutesPath.CONSUMPTION,
        feature: MenuFeatures.CONSUMPTION,
      },
      {
        title: 'New Consumo',
        icon: require("@/assets/menuIcons/consumption.png"),
        path: RoutesPath.CONSUMPTION_BY_TARIFF,
        feature: MenuFeatures.CONSUMPTION_BY_TARIFF,
      },
      {
        title: 'Alertas',
        icon: require("@/assets/menuIcons/alerts.png"),
        path: RoutesPath.CHOOSE_ALERT,
        feature: MenuFeatures.ALERTS,
      },
      {
        title: "Chamados",
        icon: require("@/assets/menuIcons/calleds.png"),
        path: RoutesPath.CALLED,
        feature: MenuFeatures.CALLEDS,
      },
      {
        title: 'Nível',
        icon: require("@/assets/menuIcons/reservoir.png"),
        path: RoutesPath.RESERVOIR,
        feature: MenuFeatures.RESERVOIR,
      },

      {
        title: "Unidades",
        icon: require("@/assets/menuIcons/units.png"),
        path: RoutesPath.UNITS,
        feature: MenuFeatures.UNITS,
      },
      {
        title: "Metas",
        icon: require("@/assets/menuIcons/goal.png"),
        path: RoutesPath.GOAL_FORECASTS,
        feature: MenuFeatures.GOAL_FORECASTS,
      },
      {
        title: "Relatórios",
        icon: require("@/assets/menuIcons/reports.png"),
        path: RoutesPath.CHOOSE_REPORT,
        feature: MenuFeatures.REPORTS,
      },
      {
        title: "Config",
        icon: require("@/assets/menuIcons/configs.png"),
        path: RoutesPath.CHOOSE_SETTING,
        feature: MenuFeatures.CONFIGS,
      },
      {
        title: "Assistente",
        icon: require("@/assets/menuIcons/chat.png"),
        path: "",
        feature: MenuFeatures.IA_AGENT,
      },
    ],
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "getCurrentUserData",
      "getCurrentUser",
      "getCurrentUserRank",
      "getCurrentUserName",
    ]),
    // Gestão deixou de ser submenu: os itens entram direto na lista, um
    // embaixo do outro, abaixo do aviso de telemetria.
    itemsMenuFilter() {
      const permissions = this.getCurrentUserData && this.getCurrentUserData.permissions;
      if (!permissions) return [];

      const allowed = ({ feature }) =>
        permissions.includes(feature) && !isMigratedFeature(feature);

      return [
        ...(hasMigratedFeature(permissions) ? [this.$options.migratedMenuItem] : []),
        ...this.subitems.filter(allowed),
        ...this.items.filter(allowed),
      ];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.drawer = val;
      }
    },
    drawer(val) {
      this.$emit('input', val);
    },
    miniValue: {
      immediate: true,
      handler(val) {
        this.mini = val;
      }
    },
    mini(val) {
      this.$emit('update:mini', val);
    }
  },
  methods: {
    ...mapActions([
      "logout",
    ]),
    isActive(item) {
     return this.$route.path === item.path;
    },
    isMdiIcon(icon) {
      return typeof icon === "string" && icon.startsWith("mdi-");
    },
    toggleMini() {
      this.mini = !this.mini;
    },
    forceWhiteColor() {
      let itemsEl = [...document.querySelectorAll("#left-menu i")]
      itemsEl.forEach(
        (el) => {
          el.style.color = "white"
        }
      )
    },
    routerDuplicated(item) {
      if(item.title === "Assistente"){
        this.$emit('open-chat');
      } else {
        this.forceWhiteColor()
        if (this.$route.path !== item.path) this.$router.push(item.path);
      }
    },
    confirmLogout() {
      store.dispatch('dialogAlert', {
        title: 'Sair do Sistema',
        text: 'Tem certeza que deseja sair do sistema?',
        open: !store.state.optionsDialogAlert.open,
        runFunc: this.executeLogout,
        closeFunc: () => {},
      });
    },
    executeLogout() {
      this.$emit('logout');
    },
  },
  mounted() {
    this.forceWhiteColor()
  }
};
</script>

<style scoped>

#left-menu {
  box-shadow: 0 0 0.5em black;
  background: linear-gradient(to bottom, #63A9FF 0%, #2471FF 100%);
  display: flex;
  flex-direction: column;
  font-family: 'Manrope', sans-serif !important;
}

.sidebar-item--active {
  background-color: #00153226;
  border-radius: 12px;
}

.sidebar-item {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0 !important;
  margin: 0 !important;
  min-height: unset !important;
  cursor: pointer;
}
.sidebar-item .v-list-item__icon {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  margin: 0 auto !important;
  width: auto !important;
}

.sidebar-item__icon {
  margin-bottom: 2px;  /* um espacinho pequeno embaixo do ícone */
}


.sidebar-item__title {
  color: white;
  font-size: 11px !important;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}

.sidebar-item__label {
  margin-top: 4px;
  text-align: center;
  color: white;
  line-height: 1;
}

.sidebar-item .v-list-item__icon v-img,
.sidebar-item .v-list-item__icon img {
  margin: 0 auto !important;
}

.logout-item {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #FFF;
  cursor: pointer;
}

/* Make all list items show a pointer cursor */
.v-list-item {
  cursor: pointer;
}

.clickable-group {
  cursor: pointer;
}

</style> 
